import { HttpOptions } from "@capacitor/core";

/* Hachenbach Marge */
/* const baseURL = "https://marge6-php80.grips.local/hachenbach-pim/web-v4/web/rest"; */
/* Hachenbach PIM */
const baseURL= "https://pim.hachenbach.de/rest";

const baseHttpOptions = (url: string) => {
    const options: HttpOptions = {
        url: `${baseURL}/${url}`,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        params: {
            'access-token': '6hFHRvJjlp266qLq'
        }
    };
    return options;
}

export default baseHttpOptions;